import { ThemeType } from 'theme/jss-types';
import { commonStyleSheet } from 'library/common-styles';

export const invoiceFieldStyles = (theme: ThemeType) => ({
    referenceItem: {
        display: 'flex',
        flexDirection: 'column',
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    contentType: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        '& .ant-form-item': {
            marginBottom: 0,
        },
    },
    invoiceFieldContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    addMoreButton: {
        margin: '10px 0',
    },
    invoiceItem: {
        marginBottom: '5px',
        padding: '10px',
        backgroundColor: '#fafafa',
        borderRadius: '5px',
        width: '100%',
    },
    invoiceItemHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    invoiceItemHeaderTitle: {
        fontWeight: 'bold',
        fontSize: 15,
        paddingTop: 10,
        paddingBottom: 10,
    },
});
